import React from "react";
import { renderTextWithBreaks } from "@/utils/stripHTML";

interface SectionTitleProps {
  title?: string;
  subtitle?: string;
  align?: "center" | "left";
  theme?: "green" | "gold" | "white" | "dark";
  subtitleColor?: "green" | "gold" | "white" | "dark" | "primaryHover" | "third" | "light-gold";
  underlineColor?: "green" | "gold" | "white" | "primaryHover" | "third";
  showLine?: boolean;
  className?: string;
}

export default function SectionTitle({
  title = "",
  subtitle,
  align = "center",
  theme = "green",
  subtitleColor,
  underlineColor,
  showLine = true,
  className = "",
}: SectionTitleProps) {
  // Main title colors based on theme
  const titleColors = {
    green: "text-secondary",
    gold: "text-secondary",
    white: "text-secondary",
    dark: "text-secondary",
  };

  // Subtitle colors
  const subColors = {
    green: "text-primary",
    gold: "text-secondary",
    white: "text-white",
    dark: "text-neutral-900",
    primaryHover: "text-primaryHover",
    third: "text-third",
    "light-gold": "text-second-4/70",
  };

  // Underline colors
  const lineColors = {
    green: "bg-primary",
    gold: "bg-secondary",
    white: "bg-white",
    primaryHover: "bg-primaryHover",
    third: "bg-third",
  };

  // Resolve defaults based on theme
  const resolvedTitleColor = titleColors[theme];
  
  // Default subtitle color
  const resolvedSubColor = subtitleColor 
    ? subColors[subtitleColor] 
    : (theme === "white" ? "text-second-4/70" : (theme === "gold" ? "text-secondary" : "text-primaryHover"));
    
  // Default underline color
  const resolvedLineColor = underlineColor 
    ? lineColors[underlineColor] 
    : (theme === "white" ? "bg-white/30" : (theme === "gold" ? "bg-secondary" : "bg-primaryHover"));

  const isCenter = align === "center";

  return (
    <div className={`space-y-2 ${isCenter ? "text-center max-w-2xl mx-auto" : "text-left"} ${className}`}>
      {subtitle && (
        <span className={`${resolvedSubColor} text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] block`}>
          {renderTextWithBreaks(subtitle)}
        </span>
      )}
      <h3 className={`text-2xl md:text-3xl font-bold ${resolvedTitleColor} uppercase tracking-wide leading-tight font-cormorant`}>
        {renderTextWithBreaks(title)}
      </h3>
      {showLine && (
        theme === "white" ? (
          <div className={`w-12 h-0.5 ${resolvedLineColor} ${isCenter ? "mx-auto" : ""} mt-3`} />
        ) : (
          <div className={`w-16 h-1 ${resolvedLineColor} ${isCenter ? "mx-auto" : ""} rounded-full mt-3`} />
        )
      )}
    </div>
  );
}
